<div class="full-width" *ngIf="runSpinner">
    <div class="loader"> </div>
</div>

<router-outlet></router-outlet>